import type {ShoppingCartSuggestiveSellingTarget} from '../types';

export interface CreateShoppingCartTargetParams {
    userId: number;
    customerId: number;
    onCartUpdated: ShoppingCartSuggestiveSellingTarget['onCartUpdated'];
}

export function createShoppingCartTarget(params: CreateShoppingCartTargetParams): ShoppingCartSuggestiveSellingTarget {
    return {
        type: 'shoppingCart',
        userId: params.userId,
        customerId: params.customerId,
        onCartUpdated: params.onCartUpdated,
    };
}
